import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonButton from "components/ArgonButton";
import ArgonInput from "components/ArgonInput";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
// baseUrl
import { baseURL } from "utils/api";
import axios from "utils/api";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";

function Index() {
  // const [subjectName, setSubjectName] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");

  const { id } = useParams();
  const navigate = useNavigate();
  console.log("time ID from URL:", id);

  //get api se board ka data lana hai id ke sath input field mai show karne ke liye
  //aur fir update karne ke liye put api call karni hai

  useEffect(() => {
    axios
      .get(`${baseURL}/slots/${id}`)
      .then((res) => {
        console.log("timeslot details:", res.data);
        const d = res.data;
        const slot = d?.data?.slot || d?.data || d?.slot || d;
        if (slot) {
          setStartTime(slot.startTime || "");
          setEndTime(slot.endTime || "");
        }
      })
      .catch((err) => {
        console.error("Error fetching subject details:", err);
      });
  }, [id]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!startTime.trim()) {
      toast.error("Start time cannot be empty");
      return;
    }
    if (!endTime.trim()) {
      toast.error("End time cannot be empty");
      return;
    }
    console.log("New Subject Added:", startTime, endTime);

    axios
      .put(`${baseURL}/slots/${id}`, {
        startTime: startTime,
        endTime: endTime,
        // name: subjectName
      })
      .then((response) => {
        console.log(response.data);
        toast.success(response.data?.message || "Subject updated successfully");
        navigate("/curriculum");
      })
      .catch((error) => {
        console.error("Error updating class:", error);
        // toast.error(error.response?.data?.message || "Failed to update class");
        toast.error(error.response?.data?.error);
      });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ArgonBox py={3}>
        <ArgonBox mb={3}>
          <Card sx={{ p: 3, borderRadius: "16px", boxShadow: 3 }}>
            <ArgonTypography mb={1} variant="h5" fontWeight="bold">
              Edit Timeslot
            </ArgonTypography>
            <Divider sx={{ mb: 3 }} />

            <form onSubmit={handleSubmit}>
              <ArgonBox display="flex" alignItems="center" gap={2}>
                {/* Input Field */}
                <ArgonBox display="flex" gap={2}>
                  <ArgonInput
                    type="time"
                    placeholder="Enter Start Time"
                    value={startTime}
                    onChange={(e) => setStartTime(e.target.value)}
                    sx={{ width: "50%" }}
                  />
                  <ArgonInput
                    type="time"
                    placeholder="Enter End Time"
                    value={endTime}
                    onChange={(e) => setEndTime(e.target.value)}
                    sx={{ width: "50%" }}
                  />
                </ArgonBox>
                {/* Button */}
                <ArgonButton
                  color="primary"
                  type="submit"
                  variant="contained"
                  // sx={{ minWidth: "150px", height: "100%" }}
                >
                  Update Time
                </ArgonButton>
              </ArgonBox>
            </form>
          </Card>
        </ArgonBox>
      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Index;
